import { IProfile } from '../../interfaces/suite8';
import { ISearchParams } from '../../interfaces/bookingContext';

export const ProfileModel: IProfile = {
  ProfileID: '',
  Gender: '',
  GuestFirstname: '',
  GuestName: '',
  ProfileType: 2,
  NationalityISO2: '',
  Birthday: null,
  Language: '',
  isValid: false,
  Email: '',
  TryToMerge: 1,
  TryToGlobalize: 1,
  Notes: [
    {
      attr: 'PRI',
      name: 'Notes',
      value: {
        market_research: false,
        third_parties: false,
        loyalty_program: false,
        promotions: false,
        privacy: false,
        privacy_req: true,
        email: false,
        mail: false,
        phone: false,
        IM: false
      }
    }
  ],
  cat: 'Adult'
};

export const SearchParamsModel: ISearchParams = {
  destination: '',
  property: '',
  GuestArrival: null,
  GuestDeparture: null,
  NoOfAdults: 2,
  Coupon: '',
  Child: {},
  Pets: false,
  status: 'to_start'
};

export const FiltersModel = {
  propertiesVisible: [],
  roomCategories: [],
  rangePriceVisible: {
    from: null,
    to: null,
    value: null
  },
  servicesVisible: [],
  isPetsAllowed: null
};
